export const articleApprovalTableGuideData = {
  id: 'eb43570a-04d6-4f7a-952c-466315d74397',
  heading: {
    id: '69312394-13f5-4935-b04c-bdad9b73a38a',
    content: "2024 Financial Position ($'M)",
  },
  rows: [
    {
      cells: [
        {
          id: '70ac3ab4-a905-4770-9eb0-3275f4963d4e',
          content: {
            id: 'content-70ac3ab4-a905-4770-9eb0-3275f4963d4e',
            content: 'SUMMARY',
          },
        },
        {
          id: '78d8d2dc-fde9-462e-aa51-45f97c20e0dd',
          content: {
            id: 'content-78d8d2dc-fde9-462e-aa51-45f97c20e0dd',
            content: 'BGC',
          },
        },
        {
          id: 'c2783b63-b8de-4ee1-a57c-8263da145d63',
          content: {
            id: 'content-c2783b63-b8de-4ee1-a57c-8263da145d63',
            content: 'B.M.D',
          },
        },
      ],
    },
    {
      cells: [
        {
          id: 'row2-col1',
          content: { id: 'row2-col1-content', content: 'Revenue' },
        },
        {
          id: 'row2-col2',
          content: { id: 'row2-col2-content', content: '1,250' },
        },
        {
          id: 'row2-col3',
          content: { id: 'row2-col3-content', content: '980' },
        },
      ],
    },
  ],
  footnotes: [],
};
